import { convertUTCToIST } from "@/utils/app-helper"

/**
 * Customer-facing order date/time (local display via existing IST helper).
 * Example: "24 Jul 2026 · 2:19 PM"
 */
export function formatOrderDetailsDateTime(isoOrUtc: string | null | undefined): string {
  const raw = String(isoOrUtc ?? "").trim()
  if (!raw) return ""
  try {
    const m = convertUTCToIST(raw)
    if (!m.isValid()) return ""
    return m.format("DD MMM YYYY · h:mm A")
  } catch {
    return ""
  }
}

/** Date-only line when time is shown separately. Example: "24 Jul 2026" */
export function formatOrderDetailsDate(isoOrUtc: string | null | undefined): string {
  const raw = String(isoOrUtc ?? "").trim()
  if (!raw) return ""
  try {
    const m = convertUTCToIST(raw)
    if (!m.isValid()) return ""
    return m.format("DD MMM YYYY")
  } catch {
    return ""
  }
}

/** Time-only. Example: "2:19 PM" */
export function formatOrderDetailsTime(isoOrUtc: string | null | undefined): string {
  const raw = String(isoOrUtc ?? "").trim()
  if (!raw) return ""
  try {
    const m = convertUTCToIST(raw)
    if (!m.isValid()) return ""
    return m.format("h:mm A")
  } catch {
    return ""
  }
}

/**
 * My Orders card line. Same instant and timezone convention as the Order Summary, list format.
 * Example: "24 Jul 2026" summary ↔ "24 Jul, 02:19 PM" card. Empty (never "now") when missing.
 */
export function formatOrderListDateTime(isoOrUtc: string | null | undefined): string {
  const raw = String(isoOrUtc ?? "").trim()
  if (!raw) return ""
  try {
    const m = convertUTCToIST(raw)
    if (!m.isValid()) return ""
    return m.format("DD MMM, hh:mm A")
  } catch {
    return ""
  }
}
